function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4
});

const SvgPosition = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "position_svg__feather position_svg__feather-user"
}, props), _ref, _ref2);

export default SvgPosition;